/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Exercises_MetaInputs */

const en_us2_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Trend of the best set over the last 5 weeks`);
	return /** @type {LocalizedString} */ (`Trend of the best set over the last 5 months`)
	
};

const pt_br2_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Tendência da melhor série nas últimas 5 semanas`);
	return /** @type {LocalizedString} */ (`Tendência da melhor série nos últimos 5 meses`)
	
};

const es_419_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Tendencia de la mejor serie en las últimas 5 semanas`);
	return /** @type {LocalizedString} */ (`Tendencia de la mejor serie en los últimos 5 meses`)
	
};

const pt_pt2_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Tendência da melhor série nas últimas 5 semanas`);
	return /** @type {LocalizedString} */ (`Tendência da melhor série nos últimos 5 meses`)
	
};

const fr_fr2_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Tendance de la meilleure série sur les 5 dernières semaines`);
	return /** @type {LocalizedString} */ (`Tendance de la meilleure série sur les 5 derniers mois`)
	
};

const de_de2_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Trend des besten Satzes in den letzten 5 Wochen`);
	return /** @type {LocalizedString} */ (`Trend des besten Satzes in den letzten 5 Monaten`)
	
};

const it_it2_progress_report_exercises_meta = /** @type {(inputs: Progress_Report_Exercises_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Andamento della serie migliore nelle ultime 5 settimane`);
	return /** @type {LocalizedString} */ (`Andamento della serie migliore negli ultimi 5 mesi`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "Trend of the best set over the last 5 weeks" |
* | * | "Trend of the best set over the last 5 months" |
*
* @param {Progress_Report_Exercises_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_exercises_meta = /** @type {((inputs: Progress_Report_Exercises_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Exercises_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_exercises_meta(inputs)
	if (locale === "es-419") return es_419_progress_report_exercises_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_exercises_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_exercises_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_report_exercises_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_report_exercises_meta(inputs)
	return en_us2_progress_report_exercises_meta(inputs)
});
export { progress_report_exercises_meta as "progress-report.exercises_meta" }